import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userName: '',
    collegeName: '',
    counts: {
        countEp: 0,
        countI: 0,
        countTI: 0,
        countT: 0,
        countEn: 0,
        countAcademic: 0,
        countCorporate: 0,
    },
    final: {},
    topScore: {},
    targetRole: {},
    initativeAvgScore: 0,
    percentage: {
        enjoymentPerct: 0,
        outcomePercent: 0,
        activityCount: 0,
    },
    resultScores: {}
};

const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState,
    reducers: {
        setUserName(state, action) {
            state.userName = action.payload;
        },
        setCollegeName(state, action) {
            state.collegeName = action.payload;
        },
        setCounts(state, action) {
            state.counts = { ...state.counts, ...action.payload };
        },
        setPercentage(state, action) {
            state.percentage = { ...state.percentage, ...action.payload };
        },
        setFinal(state, action) {
            state.final = action.payload;
        },
        setTopScore(state, action) {
            state.topScore = action.payload;
        },
        setTargetRole(state, action) {
            state.targetRole = action.payload;
        },
        setiniTativeAvgScore(state, action) {
            state.initativeAvgScore = action.payload;
        },
        setResultScores(state, action) {
            state.resultScores = action.payload;
        },
    },
});

export const { setUserName, setCollegeName, setCounts, setPercentage, setResultScores, setiniTativeAvgScore, setTargetRole, setTopScore, setFinal } = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
